import {
  required,
  minLength,
  integer,
  between,
} from 'vuelidate/lib/validators';

const allowedTypes = [
  'person',
  'trustee',
  'member',
  'director',
];

const salutations = [
  'Mr',
  'Mrs',
  'Ms',
  'Miss',
  'Dr',
  'Master',
  'Madam',
  'Prof',
  'Sir',
  'Lady',
  'Captain',
];

export default {
  name: 'fund-add-person-modal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      default: 'person',
      validator(type) {
        return allowedTypes.indexOf(type) !== -1;
      },
    },
    people: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedPerson: null,
    newPerson: false,
    person: {
      title: '',
      firstName: '',
      middleName: '',
      lastName: '',
      dob: {
        day: '',
        month: '',
        year: '',
      },
      sex: '',
    },
    salutations,
  }),
  computed: {
    modalTitle() {
      return `Add ${this.type}`;
    },
    buttonText() {
      return `Add ${this.type}`;
    },
    canAdd() {
      return !this.people.length > 0 || this.newPerson;
    },
    disableButton() {
      return !this.canAdd ? this.canAdd : this.$v.person.$invalid;
    },
  },
  methods: {
    dismiss() {
      this.clearPerson();
      this.$emit('close');
    },
    clearPerson() {
      this.person = {
        title: '',
        firstName: '',
        middleName: '',
        lastName: '',
        dob: {
          day: '',
          month: '',
          year: '',
        },
        sex: '',
      };
      this.$v.person.$reset();
    },
    handleNewPerson() {
      this.newPerson = true;
    },
    updatePerson(pos) {
      this.selectedPerson = pos;
      this.newPerson = false;
    },
    addPerson() {
      if (!this.canAdd) {
        this.$emit('person', this.people[this.selectedPerson]);
        this.dismiss();
      } else {
        this.$v.person.$touch();
        if (this.$v.person.$anyError) {
          console.log('Form errors!');
        } else {
          const dateOfBirth = new Date(
            parseInt(this.person.dob.year, 10),
            parseInt(this.person.dob.month, 10) - 1,
            parseInt(this.person.dob.day, 10),
            12,
            0,
            0,
          );
          this.person.dateOfBirth = dateOfBirth;
          delete this.person.dob;
          this.$emit('person', this.person);
          this.newPerson = false;
          this.dismiss();
        }
      }
    },
  },
  validations: {
    person: {
      title: {
        required,
      },
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      dob: {
        day: {
          required,
          integer,
          between: between(1, 31),
        },
        month: {
          required,
          integer,
          between: between(1, 12),
        },
        year: {
          required,
          integer,
          between: between(1800, new Date().getFullYear()),
        },
      },
      sex: {
        required,
      },
    },
  },
};
